var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73349 9.81797C6.08884 9.46871 6.08884 8.90451 5.73349 8.55524L2.19818 5.08049L5.73348 1.60574C6.08884 1.25647 6.08884 0.692271 5.73348 0.343005C5.37813 -0.00626177 4.8041 -0.00626172 4.44875 0.343005L0.266514 4.4536C-0.0888386 4.80287 -0.0888385 5.36707 0.266514 5.71633L4.44875 9.82693C4.79499 10.1672 5.37813 10.1672 5.73349 9.81797Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevron);
export default __webpack_public_path__ + "static/media/leftChevron.28477d1264e7de357d1e4e3990596340.svg";
export { ForwardRef as ReactComponent };